import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import TextInputField from "@my-dld/components/Form/TextInputField";
import { StringUtil } from "@eres/core";
import { PasswordMeter, validateNewPassword } from "../../../MyDLD/MyProfile/ChangePassword";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import { SSOApi } from "@eres/ssoapi";
import { replaceNavigate } from "@my-dld/utils/StoreUtils";
import { exToMessage } from "@eres/ssoapi/api";

interface Props {

}

interface State {
	newPwd: string;
	newPwdConfirm: string;
	formErrors: { [ k: string ]: string | undefined };
}

class Change extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			formErrors: {},
			newPwd: "",
			newPwdConfirm: "",
		};
	}

	isValid = () => {
		let isError = StringUtil.isEmptyStringOrNull( this.state.newPwd );
		isError = isError || StringUtil.isEmptyStringOrNull( this.state.newPwdConfirm );
		if ( !isError ) {
			const evs = Object.values( this.state.formErrors );
			isError = evs.filter( x => !StringUtil.isEmptyStringOrNull( x ) ).length !== 0;
		}
		return !isError;
	};

	render() {
		const isValid = this.isValid();
		const formProps = {
			containerClassName: "form-group mb-4 field-style",
			inputClassName: "form-control",
			holder: this,
		};
		return (
			<div>
				<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
					<div className="sso-left-panel password-change-wrapper">
						<div className="form-group password-change-title">
							<span className="password-change-title-icon"/>
							{ Strings.change_password }
						</div>
						<TextInputField
							{ ...formProps }
							placeHolder={ Strings.new_password }
							id={ "newPwd" }
							error={ this.state.formErrors.newPwd }
							label={ Strings.new_password }
							required={ true }
							maxLength={ 250 }
							inputProps={ {
								type: "password"
							} }
							onValueChange={ ( value, extra ) => {
								this.validatePwd( value );
							} }
							onValueUpdated={ ( value: string ) => {
								if ( !StringUtil.isEmptyStringOrNull( this.state.newPwdConfirm ) )
									this.validateConfirmPwd( this.state.newPwdConfirm );
							} }
						>
							<PasswordMeter value={ this.state.newPwd }/>
						</TextInputField>
						<TextInputField
							{ ...formProps }
							placeHolder={ Strings.confirm_new_password }
							id={ "newPwdConfirm" }
							error={ this.state.formErrors.newPwdConfirm }
							label={ Strings.confirm_new_password }
							required={ true }
							maxLength={ 250 }
							inputProps={ {
								type: "password"
							} }
							onValueChange={ ( value, extra ) => {
								this.validateConfirmPwd( value );
							} }
						/>
						<div className="col-md-12">
							<div className="form-group">
								<button
									disabled={ !isValid } type="button" onClick={ this.submit }
									className="btn btn_1">{ Strings.submit_label }</button>
								<a href="#/login" className="ms-3 me-3">{ Strings.cancel }</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	submit = () => {
		showLoading();
		SSOApi.forgot.update( this.state.newPwd ).then( r => {
			hideLoading();
			showMessage( Strings.password_updated );
			replaceNavigate( "/login" );
		} )
		.catch( e => {
			hideLoading();
			exToMessage( e ).then( message => {
				this.setError( "newPwd", message.error );
			} );
		} );
	};
	setError = ( key: string, error: string | undefined ) => {
		this.setState( s => {
			return {
				formErrors: {
					...s.formErrors,
					[ key ]: error,
				}
			};
		} );
	};
	validatePwd = ( value: string ) => {
		if ( StringUtil.isEmptyStringOrNull( value ) ) {
			this.setError( "newPwd", Strings.form_required_label );
		} else {
			try {
				validateNewPassword( value );
				this.setError( "newPwd", undefined );
			} catch ( e ) {
				this.setError( "newPwd", Strings.password_req_fail );
			}
		}
	};
	validateConfirmPwd = ( value: string ) => {
		if ( value !== this.state.newPwd ) {
			this.setError( "newPwdConfirm", Strings.passwords_doesnt_match );
		} else {
			this.setError( "newPwdConfirm", undefined );
		}
	};
}

export default Change;
